/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VoiceNormalIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABm0lEQVR4nOWVvUoDQRCAT7ER/MNGbEUfQEsRTkEwkuzMXGBv5kxhrZ3WmuAjaOnfA4iNpTbBBB9AEOxsVVCSWGmjsrk9jRrhklwjLhzcDMv33c7uzTrOvxielxsF4itALicOR1weAuJLIHkzT5QH4h2FfADgz7cN11r3KpJSBP8qkJsoZ+Yopcdbgruu26OITxrhjQKlZARINoD4ri5BqWYomInL71Ikh9/hjYJopFK5AUA5ClfClXQ2mGhKVCQXzYDwiyCDwaryJGXeC4VC96dEzpsK4sChsUQoVVuaLRNrrQcB5dbkEHm2cwFJACTPJpchXgylvGlLtdexwAwAWavnkc9sPGnjaycJgdZ62Jbp0cZ9dh+eEhbwQ7gC6A/ncS0RARCvhyWRUxNnPH8qsRKB5+cUyguQvCL6C1aYtyva7VxAXDNwIClEPUsh34enKnB/CpDLrR1TXom+vP6jER/bDS46SbYKbX6wDzhXYje9eM2O81FZDByRp2PB22jXxXR2acxJ8sJRyNtAsg/gzzlJXZmKpNQx7M+Nd+TXuZa9ALj+AAAAAElFTkSuQmCC)
 */
export const VoiceNormalIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 3a1 1 0 0 0-1-1h-.06a1 1 0 0 0-.74.32L5.92 7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2.92l4.28 4.68a1 1 0 0 0 .74.32H11a1 1 0 0 0 1-1V3ZM15.1 20.75c-.58.14-1.1-.33-1.1-.92v-.03c0-.5.37-.92.85-1.05a7 7 0 0 0 0-13.5A1.11 1.11 0 0 1 14 4.2v-.03c0-.6.52-1.06 1.1-.92a9 9 0 0 1 0 17.5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.16 16.51c-.57.28-1.16-.2-1.16-.83v-.14c0-.43.28-.8.63-1.02a3 3 0 0 0 0-5.04c-.35-.23-.63-.6-.63-1.02v-.14c0-.63.59-1.1 1.16-.83a5 5 0 0 1 0 9.02Z"
        className={colorClass}
      />
    </svg>
  );
};
